"use strict";

var _classCallCheck = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("D:\\Working\\meowdev\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var cssom = require("cssom");

var LinkStyleImpl = /*#__PURE__*/function () {
  function LinkStyleImpl() {
    _classCallCheck(this, LinkStyleImpl);
  }

  _createClass(LinkStyleImpl, [{
    key: "sheet",
    get: function get() {
      if (!this._cssStyleSheet) {
        this._cssStyleSheet = new cssom.CSSStyleSheet();
      }

      return this._cssStyleSheet;
    }
  }]);

  return LinkStyleImpl;
}();

module.exports = {
  implementation: LinkStyleImpl
};